import { Component, Prop, Watch } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import { RoomUserModel, ChatPrizeResponse } from '@/components/chat/_domain';
import { IChatServerService, ServerServiceSubscriptionStore } from '@/app-modules/server-service';
import { RoomUserContainer } from '@/components/chat/_domain/modules/room-user-container/room-user-container';
import { ChatContextMenuModule, IChatContextMenuFactory } from '@/components/chat/_domain/modules/chat-context-menu';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { OpenContextMenuEventName } from '@/app-modules/tombola-context-menu';

@Component({
  name: 'UserListComponent'
})
export default class UserListComponent extends TombolaBaseComponent {
  public userListSortAscending: boolean = true;
  @Prop() public server: IChatServerService;
  @Prop() public isStealth: boolean;
  @Prop() private roomUserContainer: RoomUserContainer;
  private chatContextMenu: ChatContextMenuModule = null;
  private serverSubscriptionStore: ServerServiceSubscriptionStore = null;

  private get userList(): RoomUserModel[] {
    return this.roomUserContainer ? this.roomUserContainer.userList : [];
  }

  private get userCount(): number {
    return this.roomUserContainer ? this.roomUserContainer.userListCount() : 0;
  }

  @Watch('server')
  private serverInitialised(): void {
      this.subscribeToUserListStreams();
      this.initialiseChatContextMenu();
      this.$watch('isStealth', this.toggleStealth);
  }

  private beforeDestroy() {
    this.unsubscribeFromUserListStreams();
  }

  private subscribeToUserListStreams() {
    this.serverSubscriptionStore = new ServerServiceSubscriptionStore(
      this.server.subscribeChatPrize((payload: ChatPrizeResponse) => this.updateChatPrizeStatus(payload))
    );
  }

  private unsubscribeFromUserListStreams() {
    if (this.serverSubscriptionStore) {
      this.serverSubscriptionStore.unsubscribeAll();
    }
  }

  private initialiseChatContextMenu(): void {
    const chatContextMenuFactory: IChatContextMenuFactory = this.$container.get(SERVICE_IDENTIFIERS.IChatContextMenuFactory);
    this.chatContextMenu = chatContextMenuFactory.createChatContextMenuModule(this.server);
  }

  private updateChatPrizeStatus(payload: ChatPrizeResponse): void {
    this.chatContextMenu.updateChatPrizeStatus(payload);
  }

  private toggleStealth(stealth: boolean) {
    const stealthMessage = {
      toPayload() {
        return `<admin command="stealth" enabled="${stealth}"/>`;
      }
    };
    this.server.send(stealthMessage);
  }

  public toggleSortingOrder() {
    this.userListSortAscending = !this.userListSortAscending;
    this.roomUserContainer.sortByUserTypeThenAlphabeticallyByUsername(this.userListSortAscending);
    this.$emit('onSortOrderChanged');
  }

  private userDoubleClicked(user: RoomUserModel) {
    this.$emit('onUserDoubleClicked', { user });
  }

  public launchUserContextMenu(e: MouseEvent, user: RoomUserModel) {
    this.chatContextMenu.buildUserContextMenuConfiguration(null, null, user).then((menuConfig) => {
      this.$eventbus.$emit(OpenContextMenuEventName, e, menuConfig);
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_components/user-list/user-list.component.ts